import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class LoginLinks extends Component {
	render() {
		return (
			<div className="container login-links">
                <Link className="ico-element" to={'/customer/request-password'}><span className="icon-key"></span>Forgot my password</Link>
                <Link className="ico-element" to={'/customer/create'}><span className="icon-user"></span>Create account</Link>
            </div>
        )
	}
}

export default LoginLinks



// WEBPACK FOOTER //
// ./src/components/customer/LoginLinks.js